'use strict';

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _constants = require('./constants');

var _localStorageController = require('./localStorageController');

var _localStorageController2 = _interopRequireDefault(_localStorageController);

var _applicationState = require('./applicationState');

var _parseUtils = require('./parseUtils');

var _parseUtils2 = _interopRequireDefault(_parseUtils);

var _adsSettings = require('./adsSettings');

var _adsSettings2 = _interopRequireDefault(_adsSettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  getLastPrerollDate: function getLastPrerollDate() {
    // fetch setting from local storage
    var lastPrerollDate = _localStorageController2.default.get(_constants.LocalStorage.PREROLL_LAST_PLAYED);

    if (!lastPrerollDate) {
      return;
    }

    // eslint-disable-next-line consistent-return
    return parseInt(lastPrerollDate, 10);
  },
  setLastPrerollDate: function setLastPrerollDate(lastPrerollDate) {
    _localStorageController2.default.set(_constants.LocalStorage.PREROLL_LAST_PLAYED, lastPrerollDate);
  },
  prerollAlreadyPlayed: function prerollAlreadyPlayed() {
    // don't run preroll if we're still within the interval
    var options = (0, _applicationState.getState)(_applicationState.State.options);
    var audioAdsInterval = (0, _get2.default)(options, 'audioads.interval', '300');
    var prerollInterval = 1000 * parseInt(audioAdsInterval, 10);
    var lastPrerollDate = this.getLastPrerollDate();
    return lastPrerollDate && lastPrerollDate + prerollInterval > Date.now();
  },
  prerollDisabled: function prerollDisabled() {
    // check if prerolls disabled
    var options = (0, _applicationState.getState)(_applicationState.State.options);
    var audioAdsEnabled = (0, _get2.default)(options, 'audioads.enabled', true);
    return !_parseUtils2.default.parseBool(audioAdsEnabled) || !_adsSettings2.default.canShowPrerollAds();
  }
};